import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Checkbox } from 'material-ui';

import { changePort } from 'actions/regions/ports';
import CheckDiffText from '../CheckDiffText';

class LiftAndCranesItem extends React.Component {
    render() {
        const { liftCrane, port, newPort } = this.props;

        return (
            <Fragment>
                <div className='line-head'>
                    <div className='row'>
                        <div className={
                            port.liftsCranes && newPort.liftsCranes[liftCrane.name].checked !== port.liftsCranes[liftCrane.name].checked
                                ? "col-xs-12 middle-xs dirty-element"
                                : "col-xs-12 middle-xs"
                        }>
                            <Checkbox
                                name={`liftsCranes.${liftCrane.name}.checked`}
                                label={liftCrane.label}
                                labelStyle={{ fontSize: '14px' }}
                                style={{ width: '750px' }}
                                disabled={true}
                                checked={newPort.liftsCranes[liftCrane.name].checked}
                            />
                        </div>
                    </div>
                </div>

                <div className={'line-body'}>
                    {
                        liftCrane.details.map((detail, index) => {
                            return <Fragment key={index}>
                                {
                                    detail.status === 'new' || detail.status === 'normal'
                                        ?
                                        <div className={ detail.status === 'new' ? 'item middle-xs dirty-element' : 'item middle-xs '}>
                                            <div className={"count"}>{detail ? detail.value : ''} mt</div>
                                            <div className={"name"}>{detail ? detail.name : ''}</div>
                                        </div>
                                        :
                                        ''
                                }

                                {
                                    detail.status === 'remove'
                                        ?
                                        <div className='item middle-xs dirty-element'>
                                            <div className={"count"}>
                                                <CheckDiffText
                                                    oldValue={detail ? detail.value : ''}
                                                    newValue={null}
                                                /> mt
                                            </div>

                                            <div className={"name"}>
                                                <CheckDiffText
                                                    oldValue={detail ? detail.name : ''}
                                                    newValue={null}
                                                />
                                            </div>
                                        </div>
                                        :
                                        ''
                                }

                                {
                                    detail.status === 'change'
                                        ?
                                        <div className='item middle-xs dirty-element'>
                                            <div className={"count"}>
                                                <CheckDiffText
                                                    oldValue={detail ? detail.value : ''}
                                                    newValue={detail.changes.value ? detail.changes.value : ''}
                                                /> mt</div>
                                            <div className={"name"}>
                                                <CheckDiffText
                                                    oldValue={detail ? detail.name : ''}
                                                    newValue={detail.changes.name ? detail.changes.name : ''}
                                                />
                                            </div>
                                        </div>
                                        :
                                        ''
                                }

                            </Fragment>
                        })
                    }
                </div>
            </Fragment>
        );
    }
}

LiftAndCranesItem.propTypes = {
    liftCrane: PropTypes.object,
};

LiftAndCranesItem.defaultProps = {
    liftCrane: {},
};

export default connect(
    (state, { liftCrane, newPort, port }) => {
        return { liftCrane, newPort, port };
    },
    dispatch => bindActionCreators({
        changePort,
    }, dispatch),
)(LiftAndCranesItem);



// WEBPACK FOOTER //
// ./app/components/Regions/PortApprove/LiftAndCranes/Item.jsx